import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { API_SERVICE_BY_CRM, QUERY_KEYS_BY_CRM } from "../../constants";
import { useCrmEnrichmentContext } from "../../contexts/CrmEnrichmentContext";
import type { CrmEnrichmentJob } from "../../types/types";

const useEnrichmentJobQuery = (jobId: string): UseQueryResult<CrmEnrichmentJob> => {
    const { crmProvider } = useCrmEnrichmentContext();
    const apiService = API_SERVICE_BY_CRM[crmProvider];
    const queryKeys = QUERY_KEYS_BY_CRM[crmProvider];

    return useQuery({
        enabled: !!jobId,
        queryKey: queryKeys.job(jobId),
        queryFn({ signal }) {
            return apiService.getJob(jobId, { cancellation: signal });
        },
    });
};

export default useEnrichmentJobQuery;
